import { usePermissions } from "../../Context/PermissionContext";
import { FEATURE_CODES, OPERATIONS } from "../../Static/FeatureMapping";

/**
 * Whether the current user may change a vehicle's critical configuration
 * (Project / battery config, Protocol and Bus Type) from the Edit Vehicle
 * Details dialog.
 *
 * hasPermission alone is the wrong test: on RBAC v1 it returns true for every
 * feature code, yet the backend only allows this change on an explicit v2
 * DIGITAL_TWIN.critical_update grant. Showing the option on v1 would offer
 * every v1 user a form that always ends in a 403. There is deliberately no
 * role shortcut either: ORG_ADMIN is not granted critical_update by default.
 *
 * @param {Function} hasPermission   - (featureCode, operation) => boolean
 * @param {Function} isRbacV2Enabled - () => boolean
 * @returns {boolean}
 */
export const canCriticalUpdateVehicle = (hasPermission, isRbacV2Enabled) =>
  Boolean(isRbacV2Enabled?.()) &&
  Boolean(hasPermission?.(FEATURE_CODES.DIGITAL_TWIN, OPERATIONS.CRITICAL_UPDATE));

/** Hook form of canCriticalUpdateVehicle for the current user. */
export const useCanCriticalUpdateVehicle = () => {
  const { hasPermission, isRbacV2Enabled } = usePermissions();
  return canCriticalUpdateVehicle(hasPermission, isRbacV2Enabled);
};
